import { render, staticRenderFns } from "./GoodsFileSelector.vue?vue&type=template&id=647a792e&"
import script from "./GoodsFileSelector.vue?vue&type=script&lang=js&"
export * from "./GoodsFileSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports